import { formatBusinessDateTimeFromIso } from '../dates/format-from-iso.js';
import { NOT_SET } from './not-set.js';
export function dateTimeOrNotSet(iso) {
    return formatBusinessDateTimeFromIso(iso) ?? NOT_SET;
}
//# sourceMappingURL=date-time-or-not-set.js.map